import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { ScrollBox, MinWidthBox } from './FsMinWidthScrollBox.style-elements';

interface FsMinWidthScrollBoxProps {
  minWidth?: number;
  breakpointDown?: Breakpoint;
}

const FsMinWidthScrollBox: React.FC<FsMinWidthScrollBoxProps> = ({
  children,
  minWidth,
  breakpointDown,
}) => {
  const theme = useTheme();
  const isDown = !useMediaQuery(theme.breakpoints.up(breakpointDown || 9999), {
    noSsr: true,
  });

  if (breakpointDown) {
    return isDown ? (
      <ScrollBox>
        <MinWidthBox minWidth={minWidth}>{children}</MinWidthBox>
      </ScrollBox>
    ) : (
      <>{children}</>
    );
  }

  return (
    <ScrollBox>
      <MinWidthBox minWidth={minWidth}>{children}</MinWidthBox>
    </ScrollBox>
  );
};

export default FsMinWidthScrollBox;
